"use strict";

var _classCallCheck = require("/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/createClass.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SuspenseResource = void 0;
/*
 *  Special wrapper object for the React Suspense.
 */
var SuspenseResource = /*#__PURE__*/function () {
  function SuspenseResource(fetchPromise) {
    var _this = this;
    _classCallCheck(this, SuspenseResource);
    this.state = 'pending';
    this.promise = fetchPromise.then(function (result) {
      _this.result = result;
      _this.state = 'fulfilled';
    }).catch(function (error) {
      _this.error = error;
      _this.state = 'rejected';
    });
  }
  // React Suspense only works correctly if the code behaves in a such way.
  _createClass(SuspenseResource, [{
    key: "read",
    value: function read() {
      switch (this.state) {
        case 'pending':
          throw this.promise;
        case 'rejected':
          throw this.error;
        case 'fulfilled':
          if (!this.result) throw new Error('Suspense resource is fulfilled but contains an unexpected result value.');
          return this.result;
      }
    }
  }]);
  return SuspenseResource;
}();
exports.SuspenseResource = SuspenseResource;